import type { ValueOf } from '@jane/business-admin/util';

export const ProductTableType = {
  published: 'Published',
  hidden: 'Hidden',
  unpublished: 'Unpublished',
} as const;

export type ProductTableType = ValueOf<typeof ProductTableType>;

export const isProductTableType = (test: unknown): test is ProductTableType => {
  return (
    typeof test === 'string' &&
    Object.values<string>(ProductTableType).includes(test)
  );
};
